/**
 * Toast Container
 *
 * Manages the FIFO stack of toasts in bottom-right corner.
 * Handles positioning, stacking, and animations.
 */

import { createPortal } from 'react-dom';
import { useToastContext } from './ToastContext';
import { Toast } from './Toast';

/**
 * Toast Container Component
 *
 * Renders all active toasts in a bottom-right stacked layout.
 * Uses React Portal to render outside main component tree.
 */
export function ToastContainer() {
  const { toasts, dismiss } = useToastContext();

  // Only render if there are toasts
  if (toasts.length === 0) {
    return null;
  }

  // Render toasts in a portal (outside main DOM tree)
  return createPortal(
    <div
      className="fixed bottom-0 right-0 z-50 flex flex-col-reverse gap-3 p-6 pointer-events-none"
      aria-live="polite"
      aria-label="Notifications"
    >
      {/* Render toasts in reverse order (newest at top visually) */}
      {toasts.map(toast => (
        <Toast key={toast.id} toast={toast} onDismiss={dismiss} />
      ))}
    </div>,
    document.body
  );
}
